import React from "react";
import { RefreshCcw, Handshake, ShieldCheck } from "lucide-react";

import SpokePage from "./SpokePage";
import { Star } from "./Star";
import Icon from "./Icon";
import BulletGrid from "./BulletGrid";
import { EMPLOYER_WHY, EMPLOYER_STATS } from "../../lib/adelContent";
import { cld } from "../../lib/cloudinary";

import "../preview/Design13.css";
import "../preview/Design13Audience.css";
import "./Editorial.css";

/* Dedicated page: /employers/why-adel — why clients stay, the numbers, the pledge. */
export default function EmployerWhyPage() {
  const bulletItems = EMPLOYER_WHY.map((w) => ({
    ...w,
    icon: (p) => <Icon name={w.icon} {...p} />,
  }));

  return (
    <SpokePage
      audience="employer"
      eyebrow="Why clients stay"
      title={<>The right people, <em>first time.</em></>}
      next={{ label: "See the sectors we staff", to: "/employers/sectors" }}
    >
      {/* WHY CLIENTS STAY — sand */}
      <section className="ed-band ed-band--sand ed-pad">
        <div className="ed-container">
          <BulletGrid variant="do" items={bulletItems} />
        </div>
      </section>

      {/* BY THE NUMBERS — navy, numbers with a face */}
      <section className="ed-band ed-band--ink ed-pad">
        <div className="ed-container">
          <header className="ed-opener">
            <div className="ed-opener__row">
              <span className="ed-eyebrow"><Star className="ed-eyebrow__star" /> By the numbers</span>
            </div>
            <h2 className="ed-h2">Five years. Five thousand placements. <em>One standard.</em></h2>
          </header>
          <div className="cand-stat">
            <figure className="cand-stat__face">
              <img src={cld("adel/v2/sector-construction-infrastructure", { w: 820, q: "auto", f: "auto" })} loading="lazy" alt="An Adel-placed crew on a Gulf project" />
              <figcaption className="ed-caption"><b>A placed crew</b> — Gulf project, 2024</figcaption>
            </figure>
            <ol className="cand-stat__nums cand-stat__nums--four">
              {EMPLOYER_STATS.map((c) => (
                <li key={c.l}>
                  <span className="ed-numeral">{c.v.toLocaleString()}{c.s}</span>
                  <span className="cand-stat__label">{c.l}</span>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </section>

      {/* PLEDGE — navy */}
      <section className="ed-band ed-band--ink ed-pad">
        <div className="ed-container ed-cta">
          <h2 className="ed-cta__t">Partnership, <em style={{ color: "var(--logo-orange)", fontStyle: "normal" }}>not profit.</em></h2>
          <p className="ed-cta__p">We measure success by the placements that last and the clients who come back — not by how fast we can fill a seat.</p>
          <div className="ed-pledge__badges">
            <span className="ed-pledge__badge"><Handshake size={16} strokeWidth={2} /> One accountable team</span>
            <span className="ed-pledge__badge"><RefreshCcw size={16} strokeWidth={2} /> Aftercare after arrival</span>
            <span className="ed-pledge__badge"><ShieldCheck size={16} strokeWidth={2} /> Licensed agency</span>
          </div>
        </div>
      </section>
    </SpokePage>
  );
}
